import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './hidden-widget-placeholder.scss';

/**
 * Placeholder shown for hidden widgets in drag mode
 * Allows users to make hidden widgets visible again
 */
const HiddenWidgetPlaceholder = ({ widgetName, onShow }) => {
  return (
    <div className="hidden-widget-placeholder">
      <div className="hidden-widget-placeholder__content">
        <span className="hidden-widget-placeholder__icon">
          <FontAwesomeIcon icon={['fa', 'eye-slash']} />
        </span>
        <span className="hidden-widget-placeholder__name">{widgetName}</span>
        <button
          className="hidden-widget-placeholder__button"
          onClick={(e) => {
            e.stopPropagation();
            onShow();
          }}
          title={`Show ${widgetName}`}
        >
          Show
        </button>
      </div>
    </div>
  );
};

export default HiddenWidgetPlaceholder;
